// Centralized builder for initial AI chat messages based on order status/id
// Keeps the same display structures used by Chatbot (preparing/awaiting/overview/actions)

export function buildInitialMessages({
  orderDetails,
  orderId,
  variant,
  workflowSteps,
}) {
  // console.log("Building initial messages with orderDetails:", orderDetails, "orderId:", orderId, "variant:", variant, "workflowSteps:", workflowSteps);
  if (variant !== "order-details") return [];

  // Return empty array - AILoadingCard will be shown while AI is loading
  return [];
}
